import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  Plugin, // Import Plugin type for TypeScript
} from "chart.js";

export const dayBoundaryPlugin: Plugin = {
  id: "dayBoundaryLines",
  beforeDatasetsDraw(chart) {
    const {
      ctx,
      chartArea: { top, bottom },
      scales: { x },
    } = chart;

    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = 2;
    ctx.strokeStyle = "red";
    ctx.setLineDash([5, 5]);

    const labels = chart.data.labels as string[];

    for (let i = 1; i < labels.length; i++) {
      const current = labels[i];
      const previous = labels[i - 1];

      // Check if day changed (e.g., "23" -> "00")
      const isNewDay = parseInt(current) < parseInt(previous);

      if (isNewDay) {
        // FIX: Get the exact position of the current point (00:00)
        // instead of the midpoint between points.
        const xPos = x.getPixelForValue(i);

        ctx.moveTo(xPos, top);
        ctx.lineTo(xPos, bottom);
      }
    }

    ctx.stroke();
    ctx.restore();
  },
};

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  dayBoundaryPlugin
);
